import * as Sentry from '@sentry/react';
import {
  freeSitePreviewParamName,
  visualPreviewObjectTypeParamName,
  wirechunkImpersonateAuthTokenParamName,
  wirechunkImpersonateSignOutParamName,
} from '@wirechunk/lib/mixer/visual-preview.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.tsx';
import { initialSearchParams } from './initial-search-params.ts';

const metaElements = [
  'title',
  'meta[name="description"]',
  'meta[property="og:title"]',
  'meta[property="og:description"]',
  'meta[property="og:image"]',
  'meta[name="twitter:title"]',
  'meta[name="twitter:description"]',
  'meta[name="twitter:image"]',
];

document.querySelectorAll(metaElements.join(',')).forEach((meta) => {
  meta.remove();
});

// Clear out preview and impersonation search params from the URL for two reasons:
// 1. So that users aren't confused by weird looking URLs.
// 2. So that users don't try to copy this URL to share with others (without an active subscription).
if (
  initialSearchParams.has(visualPreviewObjectTypeParamName) ||
  initialSearchParams.has(freeSitePreviewParamName) ||
  initialSearchParams.has(wirechunkImpersonateAuthTokenParamName) ||
  initialSearchParams.has(wirechunkImpersonateSignOutParamName)
) {
  initialSearchParams.delete(visualPreviewObjectTypeParamName);
  initialSearchParams.delete(freeSitePreviewParamName);
  initialSearchParams.delete(wirechunkImpersonateAuthTokenParamName);
  initialSearchParams.delete(wirechunkImpersonateSignOutParamName);
  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}?${initialSearchParams.toString()}`,
  );
}

createRoot(document.getElementById('app') as HTMLElement, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
